import { Directive, ElementRef, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';

@Directive({
  selector: '[mmFormatowanieInformacjiOObiekcie]'
})
export class FormatowanieInformacjiOObiekcieDirective {

  @Input()
  dozwoloneTagiHtml?: string;

  constructor(
    private eRef: ElementRef,
    private sanitizer: DomSanitizer
  ) { }

  @Input()
  set mmFormatowanieInformacjiOObiekcie(wartosc: string) {
    const html = this.wyczyscTagiHtml(wartosc);

    const safe = this.sanitizer.sanitize(SecurityContext.HTML, html);

    this.eRef.nativeElement.innerHTML = safe || '';
  }

  /**
   * Sprawdza czy URL jest bezpieczny
   */
  private isSafeUrl(url: string): boolean {
    return /^https?:\/\//i.test(url);
  }

  /**
   * Zamiana URL na linki
   */
  private znajdzIZamienNaLinki(text: string): string {
    const urlPattern = /(https?:\/\/[^\s()]+)/gim;

    return text.replaceAll(urlPattern, (match) => {

      if (!this.isSafeUrl(match)) {
        return match;
      }

      return `${match}`;
    });
  }

  private wyczyscTagiHtml(text: string) {

    if (!text) return '';

    text = text
      .replace(/\r\n\r\n/g, '<br /><span class="mt-1 block"></span>')
      .replace(/\r\n/g, '<br /><span class="mt-1 block"></span>')
      .replace(/\n\n/g, '<br /><span class="mt-1 block"></span>')
      .replace(/\n/g, '<br /><span class="mt-1 block"></span>');

    let div = document.createElement('div');
    div.innerHTML = text;

    let zawieraTagi = false;

    for (let i = 0; i < div.children.length; i++) {
      let child = div.children[i];

      const tag = child.tagName.toLowerCase();

      if (this.dozwoloneTagiHtml?.includes(tag)) {
        zawieraTagi = true;

        this.removeDangerousAttributes(child as HTMLElement);

        this.formatujDopuszczalneTagi(child);

      } else {
        child.remove();
        i--;
      }
    }

    if (!zawieraTagi) {
      div.innerHTML = this.znajdzIZamienNaLinki(div.innerHTML);
    }

    return div.innerHTML;
  }

  /**
   * Usuwa potencjalnie niebezpieczne atrybuty
   */
  private removeDangerousAttributes(element: HTMLElement) {
    const dangerousAttrs = ['onclick', 'onerror', 'onload', 'onmouseover'];

    dangerousAttrs.forEach(attr => {
      if (element.hasAttribute(attr)) {
        element.removeAttribute(attr);
      }
    });

    if (element.tagName.toLowerCase() === 'a') {
      const href = element.getAttribute('href');

      if (href && !this.isSafeUrl(href)) {
        element.removeAttribute('href');
      }
    }
  }

  private formatujDopuszczalneTagi(element: any) {

    if (element.tagName.toLowerCase() === 'a') {
      element.classList.add('zaznaczony-url');
      // element.setAttribute('target', '_blank');
         element.setAttribute('target', '_self');
      element.setAttribute('rel', 'noopener noreferrer');
    }

    if (element.tagName.toLowerCase() === 'img') {
      element.classList.add('zanaczony-img');
    }

    if (element.tagName.toLowerCase() === 'p') {
      element.classList.add('mt-2');
    }

    if (element.tagName.toLowerCase() === 'b') {
      element.classList.add('font-bold');
    }
  }
}
